import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import UserService from './service/user'
import shout from './service/shout'
import VueTippy, { TippyComponent } from "vue-tippy";
import VueRangeSlider from 'vue-range-component'
import VuePlyr from 'vue-plyr'
import VueKonva from 'vue-konva';

Vue.config.productionTip = false
import 'vue-select/dist/vue-select.css'
import './scss/app.scss'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

require('./service/font')

window.$ = window.jQuery = require('jquery')
require('bootstrap')
require('admin-lte')

import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'

extend('required', {
    ...required,
    message: '{_field_} is required'
})

extend('min', min);

extend('max', max);

extend('minmax', {
    validate(value, args) {
        const length = parseInt(value);

        return length >= parseInt(args.min) && length <= parseInt(args.max);
    },
    params: ['min', 'max'],
    message: 'Value not in range'
  });

extend('email', {
    ...email,
    message: '{_field_} is invalid'
})


Vue.use(VueTippy);
Vue.use(VuePlyr)
Vue.use(VueKonva);

Vue.component("tippy", TippyComponent);
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('vue-range-slider', VueRangeSlider)


const userService = new UserService
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers.common["Authorization"] = 'Bearer ' + userService.getToken()
axios.interceptors.response.use(res => res, error => {

    if (error.response.status === 401) {
        userService.removeToken()
        router.push('/login')
        return Promise.reject(error)
    }

    return Promise.reject(error)
})

window.shout = shout
